import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../authContext";
import { isLocal } from "../../../config/env";

const isAmptransEmail = (email) =>
  String(email || "").trim().toLowerCase().endsWith("@amptrans.net");

export default function InternalOpsGate() {
  const { currentUser } = useAuth();
  const allowed = Boolean(
    currentUser?.has_internal_ops_access
    || (isAmptransEmail(currentUser?.email) && (isLocal || currentUser?.entitlements?.internalops?.has_access))
  );
  if (!allowed) {
    return <Navigate to="/home" replace />;
  }
  return <Outlet />;
}
